import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered
// notifications" warning that Radix Popover / cmdk sometimes emits during
// layout settle. CRA's dev-overlay catches all errors indiscriminately and
// shows a full-screen red overlay; we suppress only this exact message and
// leave every other error untouched.
const RESIZE_OBSERVER_MSGS = [
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
];
const isResizeObserverNoise = (msg) =>
    typeof msg === "string" && RESIZE_OBSERVER_MSGS.some((m) => msg.includes(m));

window.addEventListener(
    "error",
    (e) => {
        if (isResizeObserverNoise(e?.message)) {
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    },
    true,
);
window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || String(e?.reason || "");
    if (isResizeObserverNoise(msg)) {
        e.preventDefault();
    }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
